import { UmpireReportForAdminChartConfigDto, TableChartConfigDto } from 'types/CodegenReportTypes';

import { ChartConfigProps } from 'utilities/chartIdToComponent';
import TableChartSidebar from 'components/Table/TableChartSidebar';

const UmpirePerformanceSummaryChartSidebar = (props: ChartConfigProps<TableChartConfigDto, UmpireReportForAdminChartConfigDto>) => {
  return <TableChartSidebar chartId='UmpirePerformanceSummaryChart' configKey='umpireReportPerformanceSummaryChartConfig' {...props} />;
};

export default UmpirePerformanceSummaryChartSidebar;
